// base
import React, { useMemo } from 'react';

// style
import { StyledAlarmModal } from './style';

// components
import { CenterModal, type CenterModalProps } from 'components';

export interface AlarmModalProps extends Omit<CenterModalProps, 'children'> {
  modalTitle?: React.ReactNode;
  message?: string | React.ReactNode;
  onClose: () => void;
}

export const AlarmModal: React.FC<AlarmModalProps> = ({
  message,
  onClose,
  modalTitle,
  ...props
}) => {
  const contents = useMemo(() => {
    let content: React.ReactNode = null;

    if (message == null) {
      content = null;
    } else if (typeof message === 'string') {
      content = <p>{message}</p>;
    } else {
      content = message;
    }

    return content;
  }, [message]);

  const handleClose = () => {
    onClose();
  };

  return (
    <CenterModal {...props} onClose={handleClose} modalTitle={modalTitle}>
      <StyledAlarmModal>{contents}</StyledAlarmModal>
    </CenterModal>
  );
};
